import React from 'react';
import { Navigate, useLocation } from "react-router-dom";
import { getLocalStorage } from '../helpers/localstorage';

const ProtectedRoute = ({ children }) => {
    const tokenExpirationDate = getLocalStorage("auth")?.expiration
    let location = useLocation();

    if (!tokenExpirationDate || new Date() > new Date(tokenExpirationDate)) {
        return <Navigate to="/login" state={{ from: location }} replace />
    } else {
        return children
    }


};

export default ProtectedRoute;